import { InlineStack, Icon, Select, BlockStack, Text, Button, Card, FormLayout, TextField, Bleed, Divider, Grid } from '@shopify/polaris';
import { EditMajor, EditMinor, MonerisMajor } from '@shopify/polaris-icons';
import React, { ReactElement, useContext, useState, useEffect } from 'react';
import { DIProps } from '../../../Core';
import { UserContext } from '../../../Actions/NecessaryFun';
import './styles.css';
import { useTranslation } from "react-i18next";

interface Props extends DIProps {
    priceSettings: any;
    syncNecessaryInfo: () => void;
    syncConnectorInfo: () => void;
}


const CustomCalculator = (props: any): ReactElement => {
    const { t } = useTranslation();
    const priceOptions = [
        { label: t("Please Select"), value: "", disabled: true },
        { label: t("Percentage increase"), value: "percentage_increase" },
        { label: t("Percentage decrease"), value: "percentage_decrease" },
        { label: t("Value increase"), value: "value_increase" },
        { label: t("Value decrease"), value: "value_decrease" }
    ];

    const roundOffOptions: any = [
        {
            title: t('Nearest Higher'),
            options: [
                { label: t("Whole number"), value: "higherWholeNumber" },
                { label: t("End with 9"), value: "higherEndWith9" },
                { label: t("End with 10"), value: "higherEndWith10" },
                { label: t("End with 0.49"), value: "higherEndWith0.49" },
                { label: t("End with 0.99"), value: "higherEndWith0.99" },
            ]
        },
        {
            title: 'Nearest Lower',
            options: [
                { label: t("Whole number"), value: "lowerWholeNumber" },
                { label: t("End with 9"), value: "lowerEndWith9" },
                { label: t("End with 10"), value: "lowerEndWith10" },
                { label: t("End with 0.49"), value: "lowerEndWith0.49" },
                { label: t("End with 0.99"), value: "lowerEndWith0.99" },
            ]
        },
        {
            title: t('No Rounding Off'),
            options: [
                { label: t("No round off"), value: "" },
            ]
        },
    ];


    const [baseValueOn, setBaseValueOn] = useState<boolean>(true);
    const [baseValue, setBaseValue] = useState<string>('100');
    const context: any = useContext(UserContext);
    const [showCalculator, setShowCalculator] = useState<boolean>(false);
    const [priceOption, setPriceOption] = useState<string>('');
    const [priceValue, setPriceValue] = useState<any>('0');
    const [roundOffOption, setRoundOffOption] = useState<any>('');
    const [currencyConversionSettings, setCurrencyConversionSettings] = useState<any>({});
    const [showSkeleton, setShowSkeleton] = useState<boolean>(false);

    useEffect(() => {
        props?.redux?.current?.source?.currency?.toUpperCase() != props?.redux?.current?.target?.currency?.toUpperCase() && getGlobalPriceAdjustmentSettings();
    }, []);

    const getGlobalPriceAdjustmentSettings = () => {
        setShowSkeleton(true);
        props.di.POST('connector/config/getConfig', {
            "group_code": ["currency"]
        }).then((response: any) => {
            setShowSkeleton(false);
            if (response?.success) {
                let settings = response?.data?.[0]?.value;
                setCurrencyConversionSettings(JSON.parse(JSON.stringify(settings)))
            }
            else { //front end se api call mein agar koi error hogi
                props.error(t(response?.message) ?? t("Oops! Some error occured while getting currency conversion settings."));
            }
        });
    }

    const toggleRoundOffCalculator = () => {
        setShowCalculator(!showCalculator)
    }

    const getResultAfterPriceOption = () => {
        let result: any = '';
        switch (priceOption) {
            case "percentage_increase":
                result = +baseValue + +baseValue * +priceValue / 100;
                break;
            case "percentage_decrease":
                result = +baseValue - +baseValue * +priceValue / 100;
                break;
            case "value_increase":
                result = +baseValue + +priceValue;
                break;
            case "value_decrease":
                result = +baseValue - +priceValue;
                break;
        }
        if (props?.redux?.current?.source?.currency?.toUpperCase() != props?.redux?.current?.target?.currency?.toUpperCase()) {
            result = +result * currencyConversionSettings?.target_value;
        }
        return result;
    }

    // const getCalculatedPrice = () => {
    //     let result: any = '';
    //     if (priceOption && priceValue) {
    //         let resultAfterPriceOption: any = +getResultAfterPriceOption();
    //         switch (roundOffOption) {
    //             case "higherWholeNumber":
    //                 result = Math.ceil(+resultAfterPriceOption);
    //                 break;
    //             case "higherEndWith9":
    //                 resultAfterPriceOption = resultAfterPriceOption + "";
    //                 if (resultAfterPriceOption.includes(".")) resultAfterPriceOption = resultAfterPriceOption.slice(0, resultAfterPriceOption.indexOf("."))
    //                 if (resultAfterPriceOption.length == 1) result = 9;
    //                 else {
    //                     let lastTwoDigits = resultAfterPriceOption.slice(resultAfterPriceOption.length - 2);
    //                     result = resultAfterPriceOption.slice(0, resultAfterPriceOption.length - 2) + lastTwoDigits[0] + "9";
    //                 }
    //                 break;
    //             case "higherEndWith0.99":
    //                 resultAfterPriceOption = resultAfterPriceOption + "";
    //                 if (resultAfterPriceOption.includes(".")) {
    //                     result = resultAfterPriceOption.slice(0, resultAfterPriceOption.indexOf(".") + 1) + "99";
    //                 }
    //                 else {
    //                     result = resultAfterPriceOption + ".99"
    //                 }
    //                 break;
    //             case "higherEndWith0.49":
    //                 resultAfterPriceOption = resultAfterPriceOption + "";
    //                 if (resultAfterPriceOption.includes(".")) {
    //                     result = resultAfterPriceOption.slice(0, resultAfterPriceOption.indexOf(".") + 1) + "49";
    //                 }
    //                 else {
    //                     result = resultAfterPriceOption + ".49"
    //                 }
    //                 break;
    //             case "higherEndWith10":
    //                 resultAfterPriceOption = resultAfterPriceOption + "";
    //                 if (resultAfterPriceOption.includes(".")) resultAfterPriceOption = resultAfterPriceOption.slice(0, resultAfterPriceOption.indexOf("."));
    //                 if (resultAfterPriceOption.length == 1) result = "10";
    //                 else if (resultAfterPriceOption.length == 2) result = (+resultAfterPriceOption[0] + 1) + "" + "0";
    //                 else {
    //                     let lastTwoDigits = resultAfterPriceOption.slice(resultAfterPriceOption.length - 2);
    //                     if (lastTwoDigits[0] == '9') result = (+resultAfterPriceOption.slice(0, resultAfterPriceOption.length - 1) + 1) + "" + "0";
    //                     else result = resultAfterPriceOption.slice(0, resultAfterPriceOption.length - 2) + (+lastTwoDigits[0] + 1) + "0";
    //                 }
    //                 break;
    //             case "lowerWholeNumber":
    //                 result = Math.floor(+resultAfterPriceOption);
    //                 break;
    //             case "lowerEndWith9":
    //                 resultAfterPriceOption = resultAfterPriceOption + "";
    //                 if (resultAfterPriceOption.includes(".")) resultAfterPriceOption = resultAfterPriceOption.slice(0, resultAfterPriceOption.indexOf("."))
    //                 if (resultAfterPriceOption.length == 1) result = 9;
    //                 else if (resultAfterPriceOption.length == 2) {
    //                     let first = resultAfterPriceOption[0];
    //                     let last = resultAfterPriceOption[1];
    //                     result = (+first - 1) + "" + "9";
    //                 }
    //                 else {
    //                     let lastTwoDigits = resultAfterPriceOption.slice(resultAfterPriceOption.length - 2);
    //                     let thirdLast = resultAfterPriceOption.slice(0, resultAfterPriceOption.length - 2);
    //                     if (lastTwoDigits[0] == 0) {
    //                         result = (+thirdLast - 1) + "" + "99";
    //                     }
    //                     else result = resultAfterPriceOption.slice(0, resultAfterPriceOption.length - 2) + (+lastTwoDigits[0] - 1) + "" + "9";
    //                 }
    //                 break;
    //             case "lowerEndWith0.99":
    //                 resultAfterPriceOption = resultAfterPriceOption == '0' ? 0 : +resultAfterPriceOption - 1;
    //                 resultAfterPriceOption = resultAfterPriceOption + "";
    //                 if (resultAfterPriceOption.includes(".")) {
    //                     result = resultAfterPriceOption.slice(0, resultAfterPriceOption.indexOf(".") + 1) + "99";
    //                 }
    //                 else {
    //                     result = resultAfterPriceOption + ".99"
    //                 }
    //                 break;
    //             case "lowerEndWith0.49":
    //                 resultAfterPriceOption = resultAfterPriceOption == '0' ? 0 : +resultAfterPriceOption - 1;
    //                 resultAfterPriceOption = resultAfterPriceOption + "";
    //                 if (resultAfterPriceOption.includes(".")) {
    //                     result = resultAfterPriceOption.slice(0, resultAfterPriceOption.indexOf(".") + 1) + "49";
    //                 }
    //                 else {
    //                     result = resultAfterPriceOption + ".49";
    //                 }
    //                 break;
    //             case "lowerEndWith10":
    //                 resultAfterPriceOption = resultAfterPriceOption + "";
    //                 if (resultAfterPriceOption.includes(".")) resultAfterPriceOption = resultAfterPriceOption.slice(0, resultAfterPriceOption.indexOf("."))
    //                 if (resultAfterPriceOption.length == 1) result = "0";
    //                 else if (resultAfterPriceOption.length == 2) result = resultAfterPriceOption[0] + "0";
    //                 else {
    //                     let lastTwoDigits1 = resultAfterPriceOption.slice(resultAfterPriceOption.length - 2);
    //                     result = resultAfterPriceOption.slice(0, resultAfterPriceOption.length - 2) + (+lastTwoDigits1[0]) + "0";
    //                 }
    //                 break;
    //             default:
    //                 result = resultAfterPriceOption;
    //                 break;
    //         }
    //     }
    //     return result + "";
    // }

    const getCalculatedPrice = (): string => {
        if (!(priceOption && priceValue)) return '';

        let result: number = 0;
        if (priceOption && priceValue) {
            const resultAfterPriceOption: number = +getResultAfterPriceOption();
            let rounded: number;

            switch (roundOffOption) {
                case "higherWholeNumber":
                    rounded = Math.ceil(resultAfterPriceOption);
                    break;

                case "lowerWholeNumber": {
                    const tentative = Math.floor(resultAfterPriceOption);
                    rounded = tentative > 0 ? tentative : resultAfterPriceOption;
                    break;
                }

                case "higherEndWith9": {
                    const ceilPrice = Math.ceil(resultAfterPriceOption);
                    const base = ceilPrice - (ceilPrice % 10);
                    rounded = base + 9;
                    break;
                }

                case "lowerEndWith9": {
                    const ceilPrice = Math.ceil(resultAfterPriceOption);
                    const base = ceilPrice - (ceilPrice % 10);
                    const tentative = base - 1;
                    rounded = tentative > 0 ? tentative : resultAfterPriceOption;
                    break;
                }

                case "higherEndWith0.99":
                    rounded = Math.floor(resultAfterPriceOption) + 0.99;
                    break;

                case "lowerEndWith0.99": {
                    const tentative = Math.floor(resultAfterPriceOption) - 0.01;
                    rounded = tentative > 0 ? tentative : resultAfterPriceOption;
                    break;
                }

                case "higherEndWith0.49":
                    rounded = Math.floor(resultAfterPriceOption) + 0.49;
                    break;

                case "lowerEndWith0.49": {
                    const tentative = Math.floor(resultAfterPriceOption) - 0.51;
                    rounded = tentative > 0 ? tentative : resultAfterPriceOption;
                    break;
                }

                case "higherEndWith10":
                    rounded = Math.ceil(resultAfterPriceOption / 10) * 10;
                    break;

                case "lowerEndWith10": {
                    const tentative = Math.floor(resultAfterPriceOption / 10) * 10;
                    rounded = tentative > 0 ? tentative : resultAfterPriceOption;
                    break;
                }

                default:
                    rounded = resultAfterPriceOption;
                    break;
            }

            result = rounded;

            // Final fallback safeguard
            if (result <= 0) {
                result = resultAfterPriceOption;
            }
        }

        return Number.isInteger(result) ? result + "" : parseFloat(result.toFixed(2)) + "";
    };

    if (showSkeleton) {
        return (
            <>Skeleton......</>
        )
    }
    else {
        return (
            <BlockStack gap='300'>
                <InlineStack gap='400' wrap={false}>
                    <div><Icon source={MonerisMajor} tone='info' /></div>
                    <BlockStack gap='100'>
                        <Text as='h2' variant='headingMd' fontWeight='semibold'>{t("Preview Price Rounding-off")}</Text>
                        {/* <Text as='h2' variant='headingMd'>{props.priceSettings.settings_enabled ? <Text as='span' fontWeight='semibold'>Preview price-round off</Text> : <Text as='span' tone='subdued'>Preview price-round off</Text>}</Text> */}
                        <Text as={'p'} tone='subdued'>{t(`Instantly get the real-time effects of rounding off a base price. Using the calculator, you can observe the outcomes of applying a specific percentage or fixed value change across various conditions outlined in the trend list below. Modify the base value to see the prices.`)}</Text>
                        <div><Button variant='plain' onClick={toggleRoundOffCalculator} disclosure={showCalculator ? "up" : "down"}>{`${showCalculator ? t('Hide') : t('Show')} ${t("price rounding-off calculator")}`}</Button></div>
                    </BlockStack>
                </InlineStack>
                {showCalculator ?
                    <Card>
                        <BlockStack gap="200">
                            <Grid>
                                <Grid.Cell columnSpan={{ xs: 6, sm: 3, md: 3, lg: 6, xl: 6 }}>
                                    <BlockStack gap="0">
                                        <Text as="p">{t("Base price")}</Text>
                                        <Text variant="bodySm" as="p" tone='subdued'>{`${t('Base price is considered')} ${baseValue}`}</Text>
                                    </BlockStack >
                                </Grid.Cell >
                                <Grid.Cell columnSpan={{ xs: 6, sm: 3, md: 3, lg: 6, xl: 6 }}>
                                    <InlineStack gap="200" wrap={false}>
                                        <div style={{ flex: '1' }}>
                                            <TextField disabled={baseValueOn} type='integer' value={baseValue} clearButton onClearButtonClick={() => setBaseValue('100')} label={null} autoComplete="off" onChange={(e) => setBaseValue(e)} />
                                        </div>
                                        {baseValueOn ? <Button icon={EditMinor} onClick={() => setBaseValueOn(!baseValue)} /> : <Button variant='plain' onClick={() => {
                                            setBaseValueOn(!baseValueOn);
                                            setBaseValue('100')
                                        }}>{t("Reset")}</Button>}
                                    </InlineStack>
                                </Grid.Cell>
                            </Grid >
                            < Grid >
                                <Grid.Cell columnSpan={{ xs: 6, sm: 3, md: 3, lg: 6, xl: 6 }}>
                                    <Text as="p">{t("Price Adjustment")}</Text>
                                </Grid.Cell>
                                <Grid.Cell columnSpan={{ xs: 6, sm: 3, md: 3, lg: 6, xl: 6 }}>
                                    <InlineStack gap="100" wrap={false}>
                                        <div style={{ maxWidth: '100px' }}>
                                            <TextField
                                                label=""
                                                autoComplete='off'
                                                onChange={(e: any) => {
                                                    e = e.replace(/[a-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,\/]/gi, '');
                                                    e = e?.[0] === '.' ? '0' + e : e;
                                                    e = (e.split(".").length - 1 > 1 ? e.slice(0, -1) : e).replace(/^(\d+.?\d{0,2})\d*$/, "$1");
                                                    setPriceValue(e);
                                                }}
                                                // placeholder="Enter value"
                                                value={priceValue}
                                            />
                                        </div>
                                        <div style={{ flex: '1' }}>
                                            <Select
                                                label=''
                                                options={priceOptions}
                                                onChange={(e) => setPriceOption(e)}
                                                value={priceOption}
                                            />
                                        </div>
                                    </InlineStack>
                                </Grid.Cell>
                            </Grid >
                            < Grid >
                                <Grid.Cell columnSpan={{ xs: 6, sm: 3, md: 3, lg: 6, xl: 6 }}>
                                    <Text as="p">{t("Result")}</Text>
                                </Grid.Cell>
                                <Grid.Cell columnSpan={{ xs: 6, sm: 3, md: 3, lg: 6, xl: 6 }}>
                                    <InlineStack gap='100' wrap={false}>
                                        <div style={{ maxWidth: '100px' }} className='Custom__TextField--Disabled'>
                                            <TextField disabled label='' autoComplete='off' onChange={() => { }} value={getCalculatedPrice()} />
                                        </div>
                                        <div style={{ flex: '1' }}>
                                            <Select
                                                label=""
                                                options={roundOffOptions}
                                                onChange={(e) => setRoundOffOption(e)}
                                                value={roundOffOption}
                                            />
                                        </div>
                                    </InlineStack>
                                </Grid.Cell>
                            </Grid >
                            <InlineStack><em><Text as={'span'} variant={'bodyMd'}>{`${t("Base price of the item is considered as")} ${baseValue}`}</Text></em>
                                {props?.redux?.current?.source?.currency?.toUpperCase() != props?.redux?.current?.target?.currency?.toUpperCase() && <em>&nbsp;<Text as={'span'} variant={'bodyMd'}>{`${t("and global price adjustment is")} ${currencyConversionSettings?.target_value}`}</Text></em>}</InlineStack>
                        </BlockStack >
                    </Card >
                    : <></>}
                <Bleed marginInline='500'>
                    <Divider />
                </Bleed>
            </BlockStack >
        )
    }
}

export default CustomCalculator;